import type { SparklinePoint } from "../../api/contract";

export const SPARK_LEN = 60;

export function sparkPointsFrom(points: SparklinePoint[]): number[] {
  if (!points.length) return [];
  return points.slice(-SPARK_LEN).map((point) => point.value);
}
